var endpointMap = {
	af: {
		strings: "translation-af.json"
	},
	"af-ZA": {
		strings: "translation-af.json"
	},
	ar: {
		strings: "translation-ar.json"
	},
	"ar-AE": {
		strings: "translation-ar.json"
	},
	"ar-EG": {
		strings: "translation-ar.json"
	},
	"ar-SA": {
		strings: "translation-ar.json"
	},
	bg: {
		strings: "translation-bg.json"
	},
	"bg-BG": {
		strings: "translation-bg.json"
	},
	bn: {
		strings: "translation-bn.json"
	},
	"bn-IN": {
		strings: "translation-bn.json"
	},
	cs: {
		strings: "translation-cs.json"
	},
	"cs-CZ": {
		strings: "translation-cs.json"
	},
	de: {
		strings: "translation-de.json"
	},
	"de-DE": {
		strings: "translation-de.json"
	},
	en: {
		strings: "translation-en.json"
	},
	"en-AE": {
		strings: "translation-en.json"
	},
	"en-AU": {
		strings: "translation-en.json"
	},
	"en-CA": {
		strings: "translation-en.json"
	},
	"en-EG": {
		strings: "translation-en.json"
	},
	"en-GB": {
		strings: "translation-en.json"
	},
	"en-IN": {
		strings: "translation-en.json"
	},
	"en-SA": {
		strings: "translation-en.json"
	},
	"en-SG": {
		strings: "translation-en.json"
	},
	"en-US": {
		strings: "translation-en.json"
	},
	es: {
		strings: "translation-es.json"
	},
	"es-AR": {
		strings: "translation-es.json"
	},
	"es-CL": {
		strings: "translation-es.json"
	},
	"es-CO": {
		strings: "translation-es.json"
	},
	"es-ES": {
		strings: "translation-es.json"
	},
	"es-MX": {
		strings: "translation-es.json"
	},
	"es-US": {
		strings: "translation-es.json"
	},
	fa: {
		strings: "translation-fa.json"
	},
	"fa-AF": {
		strings: "translation-fa.json"
	},
	fil: {
		strings: "translation-fil.json"
	},
	fr: {
		strings: "translation-fr.json"
	},
	"fr-CA": {
		strings: "translation-fr.json"
	},
	"fr-FR": {
		strings: "translation-fr.json"
	},
	gu: {
		strings: "translation-gu.json"
	},
	"gu-IN": {
		strings: "translation-gu.json"
	},
	ha: {
		strings: "translation-ha.json"
	},
	"ha-NG": {
		strings: "translation-ha.json"
	},
	he: {
		strings: "translation-he.json"
	},
	"he-IL": {
		strings: "translation-he.json"
	},
	hi: {
		strings: "translation-hi.json"
	},
	"hi-IN": {
		strings: "translation-hi.json"
	},
	ht: {
		strings: "translation-ht.json"
	},
	"ht-HT": {
		strings: "translation-ht.json"
	},
	hu: {
		strings: "translation-hu.json"
	},
	"hu-HU": {
		strings: "translation-hu.json"
	},
	id: {
		strings: "translation-id.json"
	},
	"id-ID": {
		strings: "translation-id.json"
	},
	ig: {
		strings: "translation-ig.json"
	},
	"ig-NG": {
		strings: "translation-ig.json"
	},
	it: {
		strings: "translation-it.json"
	},
	"it-IT": {
		strings: "translation-it.json"
	},
	ja: {
		strings: "translation-ja.json"
	},
	"ja-JP": {
		strings: "translation-ja.json"
	},
	kn: {
		strings: "translation-kn.json"
	},
	"kn-IN": {
		strings: "translation-kn.json"
	},
	ko: {
		strings: "translation-ko.json"
	},
	"ko-KR": {
		strings: "translation-ko.json"
	},
	lt: {
		strings: "translation-lt.json"
	},
	"lt-LT": {
		strings: "translation-lt.json"
	},
	lv: {
		strings: "translation-lv.json"
	},
	"lv-LV": {
		strings: "translation-lv.json"
	},
	ml: {
		strings: "translation-ml.json"
	},
	"ml-IN": {
		strings: "translation-ml.json"
	},
	mr: {
		strings: "translation-mr.json"
	},
	"mr-IN": {
		strings: "translation-mr.json"
	},
	my: {
		strings: "translation-my.json"
	},
	"my-MM": {
		strings: "translation-my.json"
	},
	ne: {
		strings: "translation-ne.json"
	},
	"ne-NP": {
		strings: "translation-ne.json"
	},
	nl: {
		strings: "translation-nl.json"
	},
	"nl-NL": {
		strings: "translation-nl.json"
	},
	pa: {
		strings: "translation-pa.json"
	},
	"pa-IN": {
		strings: "translation-pa.json"
	},
	pl: {
		strings: "translation-pl.json"
	},
	"pl-PL": {
		strings: "translation-pl.json"
	},
	ps: {
		strings: "translation-ps.json"
	},
	"ps-AF": {
		strings: "translation-ps.json"
	},
	pt: {
		strings: "translation-pt.json"
	},
	"pt-BR": {
		strings: "translation-pt.json"
	},
	"pt-PT": {
		strings: "translation-pt.json"
	},
	ro: {
		strings: "translation-ro.json"
	},
	"ro-RO": {
		strings: "translation-ro.json"
	},
	ru: {
		strings: "translation-ru.json"
	},
	"ru-RU": {
		strings: "translation-ru.json"
	},
	rw: {
		strings: "translation-rw.json"
	},
	"rw-RW": {
		strings: "translation-rw.json"
	},
	sk: {
		strings: "translation-sk.json"
	},
	"sk-SK": {
		strings: "translation-sk.json"
	},
	sl: {
		strings: "translation-sl.json"
	},
	"sl-SI": {
		strings: "translation-sl.json"
	},
	so: {
		strings: "translation-so.json"
	},
	"so-SO": {
		strings: "translation-so.json"
	},
	sv: {
		strings: "translation-sv.json"
	},
	"sv-SE": {
		strings: "translation-sv.json"
	},
	sw: {
		strings: "translation-sw.json"
	},
	"sw-KE": {
		strings: "translation-sw.json"
	},
	ta: {
		strings: "translation-ta.json"
	},
	"ta-IN": {
		strings: "translation-ta.json"
	},
	te: {
		strings: "translation-te.json"
	},
	"te-IN": {
		strings: "translation-te.json"
	},
	th: {
		strings: "translation-th.json"
	},
	"th-TH": {
		strings: "translation-th.json"
	},
	ti: {
		strings: "translation-ti.json"
	},
	"ti-ER": {
		strings: "translation-ti.json"
	},
	"tl-PH": {
		strings: "translation-fil.json"
	},
	tr: {
		strings: "translation-tr.json"
	},
	"tr-TR": {
		strings: "translation-tr.json"
	},
	uk: {
		strings: "translation-uk.json"
	},
	"uk-UA": {
		strings: "translation-uk.json"
	},
	und: {
		strings: "translation.json"
	},
	ur: {
		strings: "translation-ur.json"
	},
	"ur-PK": {
		strings: "translation-ur.json"
	},
	vi: {
		strings: "translation-vi.json"
	},
	"vi-VN": {
		strings: "translation-vi.json"
	},
	xh: {
		strings: "translation-xh.json"
	},
	"xh-ZA": {
		strings: "translation-xh.json"
	},
	yo: {
		strings: "translation-yo.json"
	},
	"yo-NG": {
		strings: "translation-yo.json"
	},
	zh: {
		strings: "translation-zh.json"
	},
	"zh-CN": {
		strings: "translation-zh.json"
	},
	"zh-TW": {
		strings: "translation-zh.json"
	},
	zu: {
		strings: "translation-zu.json"
	},
	"zu-ZA": {
		strings: "translation-zu.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
